import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";

export const MenuItemsContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    padding: 0 ${theme.spacings.md};
    display: flex;
    flex-direction: column;
    height: 90%;
    justify-content: flex-start;

    ${theme.breakpoints.md} {
      max-height: 80%;
      height: auto;
      padding: ${theme.spacings.xl} ${theme.spacings.md} 0;
    }
  `}
`;

export const ItemsContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacings.md};
    padding-bottom: ${theme.spacings.xl};
    overflow-y: auto;
  `}
`;

export const MenuItemCard = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    padding: ${theme.spacings.xs} ${theme.spacings.sm};
    border: 1px solid white;
    border-radius: 8px;
    justify-content: flex-start;
    column-gap: 14px;
    align-items: center;
    cursor: pointer;

    :hover {
      background-color: ${theme.colors.gray100};
    }
  `}
`;

export const IconContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    align-self: "center";
    align-items: center;
    justify-content: center;
    padding-top: ${theme.spacings.lg};
    margin-top: auto;

    ${theme.breakpoints.md} {
      display: none;
    }
  `}
`;
